module.exports = __webpack_public_path__ + "images/tips/board-basics@1x.96bd7c67c70221144085.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/board-basics@1x.png
// module id = 69Jq
// module chunks = 12